import { API_BASE_URL } from "../../Utils/apiConfig";

export const apiStock = async () => {
  try {
    const token = localStorage.getItem("JWT");
    const codemisor = localStorage.getItem("CodEmisor");

    const response = await fetch(`${API_BASE_URL}/api/stock?codemisor=${codemisor}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        "CodEmisor": codemisor
      },
    });

    if (response.status === 403) {
      window.location.href = "/login";
    }

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const apiStockFecha = async (fecha) => { //Copiado de Reporte fechainicio - fechafin
  try {
    const token = localStorage.getItem("JWT"); 
    const response = await fetch(`${API_BASE_URL}/api/stockfecha`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
        codemisor : localStorage.getItem("CodEmisor"),
      },
      body: JSON.stringify({
        fecha: fecha,
        codemisor : localStorage.getItem("CodEmisor"),
      }),
    });
    if (response.status === 403) {
      window.location.href = "/login";
    }
    if (response.ok) {
      const data = await response.json();
      return data;
    }      
    else {
      throw new Error('Error en la solicitud');
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
